import styled from 'styled-components';

export const SuccessIcon = styled.span`
  color: green;
`;
